import React, { useRef, useEffect, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import TeamForm from './../projectsForm/teamForm';
import { deepCopy } from '@utils/common';
import CanNotFindMemberHint from '../cannotFindMemberHint';
import { PWC_TEAM_BULK_ADD_HELPER } from './utils/bulkAddUsers.ui';

const TeamDetailFrom = (props) => {
  const teamFormRef = useRef();
  const {
    memberData,
    cRef,
    teamFormData,
    getGroupData,
    groupManip,
    setMemberOrClientChange,
  } = props;

  useEffect(() => {
    if (!teamFormData) {
      return;
    }
    const form = teamFormRef.current.getForm();
    const members = deepCopy(memberData);
    // members.splice(0, 2);
    // members = members.map((item) => item.email);
    // 请求回来之后这里设置了formList的值
    memberData.length !== 0 &&
      form.setFieldsValue({
        // engagementLead: memberData[0]?.email,
        // engagementManager: memberData[1]?.email,
        teamMember: members && [...members],
      });
  }, [teamFormData, memberData]);

  useImperativeHandle(cRef, () => ({
    getTeamForm: teamFormRef.current.getForm,
    getTeamFormValidata: (p) => teamFormRef.current.validateForm(p),
    getTeamFromRef: teamFormRef,
  }));

  return (
    <div className="pwc-team-member pwcTeamDetails">
      <div className="createPrompt1">{PWC_TEAM_BULK_ADD_HELPER}</div>
      <CanNotFindMemberHint />
      <TeamForm
        cref={teamFormRef}
        getGroupData={getGroupData}
        groupManip={groupManip}
        setMemberOrClientChange={setMemberOrClientChange}
      />
    </div>
  );
};

const mapStateToProps = ({ projects, login }) => ({
  memberData: projects.memberData,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TeamDetailFrom);
